module.exports = __webpack_public_path__ + "iq.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/iq.svg
// module id = 870
// module chunks = 0